import { Directive, ElementRef, HostListener, Input, QueryList, Renderer2, AfterViewInit, ChangeDetectorRef } from '@angular/core';

@Directive({
  selector: 'animate-on-scroll'
})
export class AnimateOnScrollDirective implements AfterViewInit {

  @Input() public elements: QueryList<ElementRef>;
  @Input() public className = 'animate';
  @Input() public startDelay = 0;
  @Input() public offset = 0;
  @Input() public staggerDelay = 0;
  @Input() public animateOnce = false;

  private hostRect: DOMRect;
  private firstPlay = true;

  constructor(
    private hostRef: ElementRef,
    private renderer: Renderer2,
    private changeDetector: ChangeDetectorRef
  ) {}

  @HostListener('scroll', ['$event'])
  private onScroll() {
    if (
      !this.hostRect ||
      this.hostRect.height !== this.hostRef.nativeElement.getBoundingClientRect().height
    ) {
      this.hostRect = this.hostRef.nativeElement.getBoundingClientRect();
    }

    this.elements.forEach((elRef, index) => {
      const elRect = elRef.nativeElement.getBoundingClientRect();
      
      // Element is fully inside container viewport
      if (
        elRect.top > this.hostRect.top &&
        elRect.top + elRect.height + this.offset < this.hostRect.top + this.hostRect.height
      ) {
        if (this.firstPlay) {
          // Animate elements already in the viewport in a staggered way on first load.
          setTimeout(() => {
            this.renderer.addClass(elRef.nativeElement, this.className);
          }, index * this.staggerDelay);
        } else {
          this.renderer.addClass(elRef.nativeElement, this.className);
        }
      }
      // Element is fully outside (below) container viewport
      else if (
        !this.animateOnce &&
        elRect.top > this.hostRect.top + this.hostRect.height
      ) {
        this.renderer.removeClass(elRef.nativeElement, this.className);
      }
    });

    if (this.firstPlay) {
      this.firstPlay = false;
    }
  }

  private setAnimationDelays(): void {
    this.elements.forEach(elRef => {
      const delay = elRef.nativeElement.getAttribute('data-anim-delay');
      if (delay) {
        this.renderer.setAttribute(elRef.nativeElement, 'style', 'animation-delay: ' + delay);
      }
    });
  }

  public triggerInitialAnimation(): void {
    this.firstPlay = true;
    
    setTimeout(() => {
      this.onScroll();
    }, this.startDelay);
  }

  public scrollToTop(): void {
    if (this.hostRef.nativeElement.scrollTop !== 0) {
      this.hostRef.nativeElement.scrollTo(0, 0);
    }
  }

  public ngAfterViewInit(): void {
    this.changeDetector.detectChanges();

    this.setAnimationDelays();
    this.triggerInitialAnimation();
  }

}
